// extracted by mini-css-extract-plugin
export default {"vacancyContactsLine":"vacancyContactsLine-module__vacancyContactsLine--AqvGY","link":"vacancyContactsLine-module__link--f_9S4"};